export var SavedReplyStatus;
(function (SavedReplyStatus) {
    SavedReplyStatus[SavedReplyStatus["DRAFT"] = 0] = "DRAFT";
    SavedReplyStatus[SavedReplyStatus["PUBLISHED"] = 1] = "PUBLISHED";
    SavedReplyStatus[SavedReplyStatus["DELETED"] = 2] = "DELETED";
})(SavedReplyStatus || (SavedReplyStatus = {}));
//# sourceMappingURL=saved-reply-status.enum.js.map